module.exports = __webpack_public_path__ + "images/skewness-12-desktop.png";